module.exports = {"pageTitle":"Notice","typePlaceholder":"Type","searchPlaceholder":"Enter a search term.","checking":"Checking","event":"Event","version":"Version","registerButton":"Register","target":"Target","type":"Type","subject":"Title","writer":"Writer","date":"Date","notEntered":"Not entered","golfClubCount":"Golf Club ({n})","noPosts":"No posts found.","prev":"Previous","next":"Next","more":"More","replyAlert1":"Registering a reply will send","replyAlert2":"a notification to the inquirer.","replyAlert3":"Do you want to register it?"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cs001.json
// module id = AUhm
// module chunks = 2